import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { FcSettings } from "react-icons/fc";
import { GiMetalBar } from "react-icons/gi";
import { FaUserAstronaut } from "react-icons/fa";
import { FaSection } from "react-icons/fa6";

export default function SidebarSettingsDropdown({ navigate }) {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const [coords, setCoords] = useState({ top: 0, left: 0 });

    // 🧠 Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                buttonRef.current &&
                !buttonRef.current.contains(e.target) &&
                !e.target.closest(".sidebar-dropdown")
            ) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    // 🧭 Toggle dropdown and calculate position
    const handleToggle = () => {
        if (!isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setCoords({
                top: rect.top + window.scrollY,
                left: rect.right + 10,
            });
        }
        setIsOpen(!isOpen);
    };

    // 📦 Dropdown menu items with icons
    const dropdownItems = [
        { label: "Material", path: "/material", icon: GiMetalBar },
        { label: "Section", path: "/sections", icon: FaSection },
        { label: "Customer", path: "/customer", icon: FaUserAstronaut },
    ];

    return (
        <>
            {/* Sidebar Settings Button */}
            <div
                ref={buttonRef}
                onClick={handleToggle}
                className="flex flex-col items-center justify-center gap-1 p-2 rounded-md w-20 cursor-pointer transition-all text-primary hover:bg-sidebarHover"
            >
                <FcSettings className="w-5 h-5" />
                <span className="text-table font-medium truncate text-center">
                    Settings
                </span>
            </div>

            {/* Dropdown beside it */}
            {isOpen &&
                createPortal(
                    <div
                        className="sidebar-dropdown absolute bg-white shadow-lg border border-gray-200 rounded-md w-48 z-50 animate-fadeIn"
                        style={{ top: coords.top, left: coords.left }}
                    >
                        {/* Scrollable Content */}
                        <div className="max-h-60 overflow-y-auto sidebar-scroll py-2">
                            {dropdownItems.map(({ label, path, icon: Icon }) => (
                                <button
                                    key={path}
                                    onClick={(e) => {
                                        e.stopPropagation(); // prevent closing before navigation
                                        navigate(path);      // navigate first
                                        setTimeout(() => setIsOpen(false), 100); // then close
                                    }}
                                    className="flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-sidebarHover hover:text-primary transition-all"
                                >
                                    <Icon className="w-4 h-4 text-gray-500" />
                                    <span>{label}</span>
                                </button>

                            ))}
                        </div>
                    </div>,
                    document.body
                )}
        </>
    );
}
